export const colors = {
  black: '#262626',
  blackOpacity: 'rgba(38, 38, 38, 0.7)',
  lightBlackOpacity: 'rgba(38, 38, 38, 0.25)',
  stroke: '#EBEBEB',
  grey: 'grey',
  white: '#fff',
  lightBlue: '#C8E3F9',
  lightBlueOpacity: 'rgba(200, 227, 249, 0.5)',
  blue: '#5095BF',
  pink: '#E44F74',
  gray: '#F9F9F9',
  warning: '#5095BF',
  error: '#EB5757',
};

export const size = {
  sm: '170px',
  lg: '470px',
};

export const textSize = {
  l: '38px',
  m: '22px',
  s: '14px',
  xs: '12px',
};

export const titleFontSize = {
  l: '38px',
  m: '22px',
};

export const cardsTitleFontSize = {
  m: '17.5px',
  xs: '14px',
};

export const cardsTitleLineHeight = {
  m: '21.33px',
};

export const shadow = {
  card: '0px 4px 44px rgba(0, 0, 0, 0.07)',
  text: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  menu: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  photoCard: '0px 7px 10px rgba(0, 0, 0, 0.5)',
  workflow: `1px 1px 6px ${colors.grey}`,
  menuFilter: 'drop-shadow( 3px 3px 2px rgba(0, 0, 0, .07))',
  section: '0px 4px 44px rgba(0, 0, 0, 0.03)',
  modal: '0px 0px 10px rgb(0 22 79 / 30%)',
};

export const transition = {
  easeInOutCubic: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  easeOutBack: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  duration: '0.5s',
};

export const theme = {
  foreground: '#050505',
  background: 'white',
  faded: '#888',
  colors,
  textSize,
  titleFontSize,
  cardsTitleFontSize,
  cardsTitleLineHeight,
  size,
  shadow,
  breakpoints: {
    xs: '400px',
    s: '600px',
    m: '900px',
    l: '1200px',
    xl: '1400px',
  },
  fontFamily: {
    // eslint-disable-next-line
    body: `Open Sans,-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
    // eslint-disable-next-line
    heading: `'Montserrat', sans-serif`,
    footer: `Montserrat, sans-serif`,
  },
  fontWeights: {
    button: 'bold',
  },
  fontWeight: {
    button: `bold`,
  },
  layout: {
    article: '46rem',
    base: '70rem',
    big: '83.33333rem',
    containerWidth: {
      s: '95%',
      m: '90%',
      l: '1170px',
      xl: '1170px',
    },
  },
  borders: {
    card: '1px solid #EBEBEB',
  },
  borderRadius: {
    default: '6px',
    round: '10px',
    bigRound: '20px',
  },
  transitions: {
    default: {
      duration: transition.duration,
      timing: transition.easeInOutCubic,
      transition: `all ${transition.duration} ${transition.easeInOutCubic}`,
    },
    boom: {
      duration: transition.duration,
      timing: transition.easeOutBack,
      transition: `all ${transition.duration} ${transition.easeOutBack}`,
    },
    cardHover: '0.4s ease-out',
  },
  button: {
    borderRadius: '10px',
    3: {
      bgColor: `${colors.grey}`,
      textColor: `${colors.black}`,
      border: 0,
      hover: {
        bgColor: `${colors.lightBlue}`,
        textColor: `${colors.black}`,
      },
    },
  },
  // define canvas size for static templates
  canvas: {
    portrait: { width: '500px', height: '661px' },
    landscape: { width: '661px', height: '500px' },
  },
};

export default theme;
